import React from 'react';
import { FiFileText } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const Weeklydrivehome = ({token}) => {

    const navigate = useNavigate();
         const handleNavigate = () => {
       const path = token ? `/driver-form?allow=${token}` : '/driver-form';
       navigate(path);
     };
  return (
<div
  className="mt-10 bg-white shadow-lg rounded p-4 px-6 border-[1.5px] border-gray-100
  flex flex-col justify-between
  transform transition-all"
>
  {/* Title */}
  <div className="text-[13px] font-semibold text-left">
    WEEKLY DRIVER LOG & SAFETY
  </div>

  {/* Bottom buttons */}
  <div className="flex gap-2 mt-6">
    <button
      onClick={handleNavigate}
      className="bg-black text-xs text-white py-2 rounded flex items-center justify-center gap-1 transition hover:bg-gray-900 whitespace-nowrap px-1"
    >
      <FiFileText className="text-sm flex-shrink-0" />
      Fill out Form
    </button>
    <button
      onClick={() => navigate('/merge-dashboard?type=weekly')}
      className="bg-[#1E4976] text-xs text-white py-2 flex-1 rounded flex items-center justify-center gap-1 transition hover:bg-blue-700 whitespace-nowrap"
    >
      Reports
    </button>
  </div>
</div>

  );
};

export default Weeklydrivehome;


